import { useEffect, useState } from 'react';
import Icon from './Icon';
export default function DishImage({ src, alt, className, loading }) {
  const [unavailable, setUnavailable] = useState(false);
  useEffect(() => setUnavailable(false), [src]);
  if (unavailable) return <span className={`${className} image-placeholder`} role="img" aria-label={`Immagine non disponibile: ${alt}`}><Icon name="menu" size={28} /></span>;
  return <img src={src} alt={alt} className={className} loading={loading} onError={() => setUnavailable(true)} />;
}
